/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RunTestsCommand } from '../../models/run-tests-command';
import { RunTestsResult } from '../../models/run-tests-result';

export interface ApiTestRunsPost$Params {

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
      body?: RunTestsCommand
}

export function apiTestRunsPost(http: HttpClient, rootUrl: string, params?: ApiTestRunsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<RunTestsResult>> {
  const rb = new RequestBuilder(rootUrl, apiTestRunsPost.PATH, 'post');
  if (params) {
    rb.header('x-space-id', params['x-space-id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RunTestsResult>;
    })
  );
}

apiTestRunsPost.PATH = '/api/test-runs';
